"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/Reports/components/PatientPanel.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _upgrade = require('shared/enum/upgrade');
var _user = require('shared/selectors/user');
var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);
var _hooks = require('web/services/hooks');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _UpgradeModal = require('web/components/Upgrade/UpgradeModal'); var _UpgradeModal2 = _interopRequireDefault(_UpgradeModal);
var _PatientDrawer = require('web/screens/Directory/PatientTable/PatientDrawer'); var _PatientDrawer2 = _interopRequireDefault(_PatientDrawer);
var _PatientActions = require('web/screens/Directory/PatientTable/PatientActions'); var _PatientActions2 = _interopRequireDefault(_PatientActions);

// A patient link in the log switches the panel itself, so a click on one
// keeps it open.
 const PATIENT_LINK_CLASS = 'settings--org-reports--patient'; exports.PATIENT_LINK_CLASS = PATIENT_LINK_CLASS
const KEEPS_OPEN = `${_PatientDrawer.DRAWER_KEEPS_OPEN}, .${exports.PATIENT_LINK_CLASS}`







/* The Directory's patient panel (RP-4), over Reports: the same PatientDrawer
 * and the same actions (tag, add to campaign, archive). It reads the
 * patient's table row as the Directory does. Message opens the patient in
 * Directory, where a new chat starts. */
const PatientPanel = ({ orgKey, patientKey, onClose }) => {
  const isAdmin = _hooks.useAppSelector.call(void 0, state => _user.selectAmIAdminInOrg.call(void 0, state, orgKey))
  const [row, setRow] = _react.useState(null)
  const [reloads, setReloads] = _react.useState.call(void 0, 0)
  _react.useEffect.call(void 0, () => {
    let isCurrent = true
    _actions2.default.getPatientTableRow({ OrgKey: orgKey, PatientKey: patientKey })
      .then(r => { if (isCurrent) setRow(r.Patient) })
      .catch(() => undefined)
    return () => { isCurrent = false }
  }, [orgKey, patientKey, reloads])

  const [tags, setTags] = _react.useState([])
  const loadTags = _react.useCallback.call(void 0, 
    () => _actions2.default.listPatientTags({ OrgKey: orgKey }).then(r => setTags(r.Tags)).catch(() => undefined),
    [orgKey],
  )

  const [action, setAction] = _react.useState(null)
  const onAction = _react.useCallback.call(void 0, (a) => {
    if (_optionalChain([a, 'optionalAccess', _ => _.kind]) === 'tag') loadTags()
    setAction(a)
  }, [loadTags])
  const onRemoveTag = _react.useCallback.call(void 0, 
    (tag) => setAction({ kind: 'untag', patientKeys: [patientKey], tag, isArchived: !!_optionalChain([row, 'optionalAccess', _2 => _2.Archived]) }),
    [patientKey, row],
  )
  const onDone = _react.useCallback.call(void 0, () => setReloads(n => n + 1), [])
  // An archive or restore of this patient runs in the background; the panel
  // closes as the Directory's does.
  const onArchiveStarted = _react.useCallback.call(void 0, 
    (_taskKey, task) => { if (task.closesPanel) onClose() },
    [onClose],
  )
  const selection = _react.useMemo.call(void 0, () => ({ PatientKeys: [patientKey] }), [patientKey])

  const onStartChat = _react.useCallback.call(void 0, () => _actions2.default.gotoPatientPage(orgKey, patientKey), [orgKey, patientKey])
  const { isOpen: isUpsellOpen, onOpen: onOpenUpsell, onClose: onCloseUpsell } = _useToggle2.default.call(void 0, )

  _react.useEffect.call(void 0, () => {
    // Capture, as the Directory does: a click outside the panel closes it.
    const onClick = (e) => {
      const target = e.target
      if (target instanceof Element && target.isConnected && !target.closest(KEEPS_OPEN)) onClose()
    }
    document.addEventListener('click', onClick, true)
    return () => document.removeEventListener('click', onClick, true)
  }, [onClose])

  return (
    _react2.default.createElement('div', { className: "settings--org-reports--drawer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}
      , _react2.default.createElement(_PatientDrawer2.default, {
        orgKey: orgKey,
        patientKey: patientKey,
        row: row,
        isAdmin: isAdmin,
        onClose: onClose,
        onAction: onAction,
        onRemoveTag: onRemoveTag,
        onRequestPatientsFeature: onOpenUpsell,
        onStartChat: onStartChat, __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}
      )
      , _react2.default.createElement(_PatientActions2.default, {
        orgKey: orgKey,
        action: action,
        onAction: onAction,
        onDone: onDone,
        selection: selection,
        selectedCount: 1,
        description: "",
        tags: tags,
        isArchivedView: !!_optionalChain([row, 'optionalAccess', _3 => _3.Archived]),
        onArchiveStarted: onArchiveStarted, __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}
      )
      , _react2.default.createElement(_UpgradeModal2.default, { orgKey: orgKey, type: _upgrade.SubscriptionItemType.SMS, isOpen: isUpsellOpen, onClose: onCloseUpsell, __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}} )
    )
  )
}

exports. default = PatientPanel
